(() => {
  const KEY = 'nova-collection-state';

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const sectionId = root.dataset.sectionId;
    const grid = root.querySelector('[data-grid]');
    let pages = 1;

    const sort = root.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    const updateProgress = () => {
      const box = root.querySelector('[data-progress]');
      if (!box || !grid) return;
      const total = parseInt(box.dataset.total, 10) || 0;
      const shown = grid.querySelectorAll('[data-card]').length;
      const text = box.querySelector('[data-progress-text]');
      const bar = box.querySelector('[data-progress-bar]');
      if (text) text.textContent = text.dataset.template.replace('__shown__', shown).replace('__total__', total);
      if (bar) bar.style.width = `${total ? Math.round((shown / total) * 100) : 0}%`;
    };

    const loadMore = async () => {
      const btn = root.querySelector('[data-load-more]');
      if (!btn || !grid) return false;
      btn.classList.add('is-loading');
      const url = new URL(btn.href, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      try {
        const html = await fetch(url.toString()).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-grid]');
        if (nextGrid) Array.from(nextGrid.children).forEach((c) => grid.appendChild(c));
        const nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn) {
          btn.href = nextBtn.getAttribute('href');
          btn.classList.remove('is-loading');
        } else {
          btn.remove();
        }
        pages++;
        updateProgress();
        if (window.Nova && Nova.wishlist) Nova.wishlist.sync();
        return true;
      } catch (e) {
        btn.classList.remove('is-loading');
        return false;
      }
    };

    root.addEventListener('click', (e) => {
      const more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        loadMore();
        return;
      }
      const link = e.target.closest('[data-grid] a');
      if (link) {
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ path: window.location.pathname + window.location.search, pages, y: window.scrollY }));
        } catch (err) {}
      }
    });

    /* Terug van een product: dezelfde pagina's en scrollpositie herstellen */
    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {}
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    const isBack = nav && nav.type === 'back_forward';
    if (saved && isBack && saved.path === window.location.pathname + window.location.search) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      (async () => {
        for (let i = 1; i < saved.pages; i++) {
          const ok = await loadMore();
          if (!ok) break;
        }
        window.scrollTo(0, saved.y);
      })();
    }
  };

  const boot = () => document.querySelectorAll('[data-collection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
